export default __webpack_public_path__ + "static/media/car.352a96b0.jpg";